import { createContext, useContext, useEffect, useState } from 'react'
import { type IUser } from '#app/models/user._._definitions.ts';
import axiosClient from '#app/utils/axios-client'

type RootData = {
	user?: IUser
	ENV?: { PUSH_PUBLIC_KEY?: string; ONE_SIGNAL_APP_ID?: string }
	honeyProps?: any
}

const RootDataContext = createContext<{
	data: RootData | null
	loading: boolean
	refresh: (useLoading?: boolean) => Promise<void>
	setData: React.Dispatch<React.SetStateAction<RootData | null>>
}>({
	data: null,
	loading: true,
	refresh: async () => {},
	setData: () => {},
})

export function RootDataProvider({ children }: { children: React.ReactNode }) {
	const [data, setData] = useState<RootData | null>(null)
	const [loading, setLoading] = useState(true)

	const refresh = async (useLoading: boolean = true) => {
		if (useLoading) setLoading(true)
		try {
			const response = await axiosClient.get('/api/root-data')
			setData(response.data)
		} catch {
			setData(null)
		} finally {
			if (useLoading) setLoading(false)
		}
	}

	useEffect(() => {
		refresh().then().catch(() => {})
	}, [])

	return (
		<RootDataContext.Provider value={{ data, loading, refresh, setData }}>
			{children}
		</RootDataContext.Provider>
	)
}

export function useRootData() {
	return useContext(RootDataContext)
}
